import type { ClientCancellationSuspensionPolicyDto } from '../../types/clientCancellationLines';
import { CLIENT_CANCELLATION_SUSPENSION_BLOCK_MESSAGE } from './clientCancellationLinesLabels';

/** `false` só quando a API envia explicitamente `suspensaoPermitida: false`. */
export function contratoPermiteSuspensao(
  suspensaoPermitida: boolean | null | undefined
): boolean {
  return suspensaoPermitida !== false;
}

export function mensagemSuspensaoBloqueada1056(
  policy?: ClientCancellationSuspensionPolicyDto | null
): string {
  const msg = policy?.message?.trim();
  return msg || CLIENT_CANCELLATION_SUSPENSION_BLOCK_MESSAGE;
}

export function deveExibirBannerPoliticaSuspensao(
  policy?: ClientCancellationSuspensionPolicyDto | null
): boolean {
  return policy?.blockNewSuspensions === true;
}
